import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name:       'formatUpperCase',
  standalone: true
})
export class FormatUppercasePipe implements PipeTransform {

  transform(value: string): string {
    return value.trim()
      .toUpperCase();
  }
}
